
const validate = (props) => {
    const errors = {}

    if (!props.code) {
        errors.code = 'يرجي ادخال الكود'
    }else if(isNaN(Number(props.code))) {

        errors.code = "يرجي ادخال الكود صحيحا"
    }
    return errors
}

export default validate;